<template>
  <div id="app">
  	<shortCut/>
  	<Header v-if="$route.meta.showHead"/>
    <router-view class="mainContent" v-if="apiFinish"/>
    <Footer/>
  </div>
</template>

<script>
import shortCut from '@/components/ShortCut'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

import * as INDEX_API from '@/api/index'
import both from '@/utils/storage'

import { mapActions,mapGetters } from 'vuex'
export default {
  name: 'app',
  components: {
  	shortCut,
  	Header,
  	Footer,
  },
  data() {
    return {
      /* 必要的接口加载完毕 */
      apiFinish: 0
    }
  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    /* 获取币种 */
    getCurrency() {
      return new Promise((resolve, reject)=> {
        let currencyList = both.storage_tmp.get('currencyList')
        if (currencyList.length == 0) {
          INDEX_API.getCurrency().then((res)=>{
            /* 设置支付方式，汇率 */
            let data = res.data.map(obj=> {
              obj['huilv'] = {}
              if (obj.way != '') {
                let templateWay = obj.way
                templateWay.split(',').forEach(item=> {
                  let arr = item.split('-')
                  obj['huilv'][arr[0]] = arr[1] == undefined ? 0 : arr[1]

                })

                // 费用费率列表
                let huilvs = JSON.parse(obj.fee_list)
                let resultItems = {}
                huilvs.forEach(obj=> {
                  resultItems[Object.keys(obj)[0]] = obj[Object.keys(obj)[0]]
                })
                obj['huilvList'] = resultItems
                obj.way = obj.way.replace(/[0-9.-]/g,'')
                return obj
              }
            })
            both.storage_tmp.set('currencyList', data)
            this.$store.dispatch('currencyList', data)
            resolve()
          })
        }else{
          this.$store.dispatch('currencyList', currencyList)
          resolve()
        }
      })
    },
    /* 获取国家列表 */
    getCountryList() {
      return new Promise((resolve, reject)=> {
        let countryList = both.storage_tmp.get('countryList')
        if (countryList.length == 0) {
          INDEX_API.getCountryList().then((res)=>{
            both.storage_tmp.set('countryList', res.data)
            this.$store.dispatch('countryList', res.data)
            resolve()
          })
        }else{
          this.$store.dispatch('countryList', countryList)
          resolve()
        }
      })
    },
    /* FAQ */
    getFAQ() {
      return new Promise((resolve, reject)=> {
        let FAQ = both.storage_tmp.get('FAQ')
        if (Object.keys(FAQ).length == 0) {
          INDEX_API.getFAQ().then((res)=>{
            both.storage_tmp.set('FAQ', res.data)
            this.$store.dispatch('FAQ', res.data)
            resolve()
          })
        }else{
          this.$store.dispatch('FAQ', FAQ)
          resolve()
        }
      })
    }
  },
  created() {


    /* 需要使用国家、币种的页面，等待api请求完成 */
    let needRouteName = ['Recharge', 'Pay']
    let needPathname = ['/recharge', '/pay']
    const routeNameBool = needRouteName.indexOf(this.$route.name) > -1
    const pathNameBool = needPathname.indexOf(window.location.pathname) > -1
    if (routeNameBool || pathNameBool) {
      Promise.all([this.getCurrency(), this.getCountryList(), this.getFAQ()]).then(res=> {
        this.apiFinish = 1
      })
    }else{

      /* 获取币种 */
      this.getCurrency()
      /* 获取国家列表 */
      this.getCountryList()
      /* 获取FAQ */
      this.getFAQ()

      this.apiFinish = 1
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh
}
</style>
<style lang="scss" scoped>
.mainContent{
  min-height: calc(100vh - 30px - 267px)
}
</style>